import Input from "@/components/ui/Input";

interface StepNameIdentityProps {
  displayName: string;
  onDisplayNameChange: (name: string) => void;
  title: string;
  onTitleChange: (title: string) => void;
  titleManuallyEdited: boolean;
  onTitleManualEdit: () => void;
  onTitleClear: () => void;
}

export default function StepNameIdentity({
  displayName,
  onDisplayNameChange,
  title,
  onTitleChange,
  titleManuallyEdited,
  onTitleManualEdit,
  onTitleClear,
}: StepNameIdentityProps) {
  const handleTitleChange = (value: string) => {
    onTitleChange(value);
    if (value === "") {
      onTitleClear();
    } else {
      onTitleManualEdit();
    }
  };

  return (
    <div>
      <h2 className="font-display text-xl font-bold text-text">
        Who Are You?
      </h2>
      <p className="mt-1 text-sm text-text-secondary">
        Your name will be shown to other players
      </p>

      <div className="mt-5 space-y-5">
        <Input
          label="Your Display Name"
          value={displayName}
          onChange={(e) => onDisplayNameChange(e.target.value)}
          placeholder="e.g. Alex"
          maxLength={30}
          required
        />

        <div>
          <Input
            label="Game Title"
            value={title}
            onChange={(e) => handleTitleChange(e.target.value)}
            placeholder="e.g. Park Scavenger Hunt"
            maxLength={100}
            required
          />
          {!titleManuallyEdited && title && (
            <p className="mt-1 text-xs text-text-secondary">
              Auto-generated from your name. Edit to customize.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
